import Swiper from 'swiper'

export default class Carousel {
  /**
  ** 実行
  ** @constructor
  **/      
  constructor() {
    this.getParam()
    this.bindEvent()
  }

   /**
  ** 各種要素を取得している
  ** @getParam
  **/   
  getParam() {
    this.checkItem = document.querySelector(`[data-module='check-items']`)
    if(this.checkItem) {
      this.checkItemLength = this.checkItem.children.length      
    }
    this.checkAdSlideInitNum = 6
  }



  /**
  ** swiperを実行
  ** @bindEvent
  **/    
  bindEvent() {

    const
      elem01 = document.getElementsByClassName('js-index-top-carousel')[0],
      elem02 = document.getElementsByClassName('js-bnr-slider')[0],
      elem03 = document.getElementsByClassName('js-licence-slider')[0]



    if(elem01) {
      var mySwiper = new Swiper ('.js-index-top-carousel', {
        spaceBetween: 20,
        slidesPerView: 1.227,
        loop: true,
        centeredSlides:true,
        autoplay: 2000,
        speed:1000,
        breakpoints: {
          768: {
            slidesPerView: 1.12,
            spaceBetween: 8,
          }
        }
      })   
    } 
    if(elem02) {
      var mySwiper03 = new Swiper ('.js-bnr-slider', {
        spaceBetween: 14,
        loop: true,
        centeredSlides:false,
        slidesPerView: 3,
        autoplay: 2000,
        speed:1000,
        breakpoints: {  
          768: {
            slidesPerView: 2,
            spaceBetween: 10
          }
        }      
      })
    }
    
    if(elem03) {
      var mySwiper05 = new Swiper ('.js-licence-slider', {
        spaceBetween: 14,
        loop: true,
        centeredSlides:false,
        slidesPerView: 1,
        autoplay: 2000,
        speed:1000,
        nextButton: '.js-ad-button-next',
        prevButton: '.js-ad-button-prev',        
        breakpoints: {  
          768: {
            spaceBetween: 1
          }
        }      
      })
    }
    

    if(this.checkItemLength)  {
      // 5個以上アイテムがあった場合に実行
      if(this.checkAdSlideInitNum < this.checkItemLength ) {

        var mySwiper02 = new Swiper ('.js-multi-carousel', {
          spaceBetween:22,
          loop: false,
          speed:1000,
          centeredSlides:false,
          nextButton: '.js-ad-button-next',
          prevButton: '.js-ad-button-prev',
          width:114,

          breakpoints: {
            768: {
              width:60,
              loop: false,
              spaceBetween: 15,
              centeredSlides:false,
            }
          }
        })  
        
        var mySwiper04 = new Swiper ('.js-multi-carousel-02', {
          spaceBetween:22,
          loop: false,
          speed:1000,
          centeredSlides:false,
          initialSlide: 1,
          nextButton: '.js-rel-button-next',
          prevButton: '.js-rel-button-prev',
          width:114,
          breakpoints: {
            768: {
              width:60,
              loop: false,
              spaceBetween: 15,
              centeredSlides:false,
            }
          }
        })          
      }  
    }  
  }

  
}